import React, { useState } from 'react';
import Breadcrumbs from '../../components/BreadCrumbs';
import ImagePicker from '../../components/inputFields/ImagePicker';
import StyledHeadingText from '../../components/Fonts/StyledHeadingText';
import CustomRowText from '../../components/CustomRowText';
import TabView from '../../components/TabView';
import OwnerDetails from './OwnerDetails';
import StoreDetailsView from './StoreDetailsView';
import AddressView from './AddressView';

function StoreDetails() {
    const [activeTab, setActiveTab] = useState("Owner Details");
    const [shopLogo, setShopLogo] = useState(null);


    const handleStoreLogoeSelect = (file) => {
        setShopLogo(file);
    };

    const handleTabChange = (value) => {
        setActiveTab(value);
    };

    return (<>
        <Breadcrumbs items={[
            { name: 'Home', link: '/dashboard' },
            { name: 'Store Details' },
            { name: activeTab },
        ]} />
        <div className="py-3">
            <StyledHeadingText text={"Store Details"} />
        </div>
        <div className="flex flex-col bg-white rounded-lg shadow-md items-center sm:flex-row mb-4">
            <div className="flex flex-row p-4 gap-2 items-center w-full sm:w-auto">
                <div className="w-36 aspect-square">
                    <ImagePicker
                        preloadedImage={shopLogo}
                        onImageSelect={handleStoreLogoeSelect}
                        disabled={true}
                    />
                </div>
                <div className="flex flex-col h-24 justify-center">
                    <div className="flex flex-col">
                        <StyledHeadingText text={"Rashail Agro"} />
                        <small>Prop. Saral Jain</small>
                    </div>
                    <div className="flex flex-col">
                        <p className="mt-8">Store ID:</p>
                        <StyledHeadingText text={"R-AGRO-123"} />
                    </div>
                </div>
            </div>
            <div className="sm:ml-8 flex bg-slate-800 h-full rounded-lg p-4 flex-col justify-between w-full sm:w-auto sm:flex-1">
                <CustomRowText title={"Owner"} value={"Saral Jain"} titleColor='text-[#ffffff]' valueColor='text-[#ffffff]' />
                <CustomRowText title={"Phone No."} value={"+91260293619"} titleColor='text-[#ffffff]' valueColor='text-[#ffffff]' />
                <CustomRowText title={"Username"} value={"saral_jain"} titleColor='text-[#ffffff]' valueColor='text-[#ffffff]' />
                <CustomRowText title={"Password"} value={"**********"} titleColor='text-[#ffffff]' valueColor='text-[#ffffff]' />
            </div>
        </div>
        <TabView
            onChanged={handleTabChange}
            isCenterAligned={false}
            tabs={[
                {
                    key: 'Owner Details',
                    title: 'Owner Details',
                    content: (
                        <OwnerDetails />
                    ),
                },
                {
                    key: 'Store Details',
                    title: 'Store Details',
                    content: (
                        <StoreDetailsView />
                    ),
                },
                {
                    key: 'Address Details',
                    title: 'Address Details',
                    content: (
                        <AddressView />
                    ),
                },
                {
                    key: 'Business Details',
                    title: 'Business Details',
                    content: (
                        <></>
                    ),
                },
                {
                    key: 'Licences',
                    title: 'Licences',
                    content: (
                        <></>
                    ),
                },
                {
                    key: 'Certifications',
                    title: 'Certifications',
                    content: (
                        <></>
                    ),
                },
            ]} />
    </>);
}

export default StoreDetails;